// noinspection JSUnusedGlobalSymbols

import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the unit tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['simCards/findSimCardsWidgetModule/get']
}

/**
 * Returns the sets of selected SIM cards.
 *
 * @return Object
 */
export const selectedSimCardSets = () => {
  return store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets']
}

/**
 * Returns SIM cards that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedSimCards = (set) => {
  if (store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    return store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns SIM cards that are selected for the specified set as an array
 *
 * @param set String
 *
 * @return Array
 */
export const selectedSimCardsAsArray = (set) => {
  if (store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    const simCards = store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'][set]
    const simCardIds = Object.keys(simCards)
    let results = []
    simCardIds.forEach(simCardId => {
      results.push(simCards[simCardId])
    })
    return results
  } else {
    return []
  }
}

/**
 * Return an array of integers of the selected SIM cards.
 *
 * @param set String
 * @returns [int]
 */
export const getSelectedSimCardIds = (set) => {
  if (store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    const simCards = store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'][set]
    return Object.keys(simCards).map(key => parseInt(key))
  } else {
    return []
  }
}

/**
 * Returns the first selected unit in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedSimCard = (set) => {
  if (store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    const simCards = store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'][set]
    const simCardIds = Object.keys(simCards)
    if (simCardIds.length > 0) {
      return simCards[simCardIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns true if the specified unit is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedSimCards(set).hasOwnProperty(id)
}

/**
 * Returns either a client object or null depending on whether
 * queries should be made by client.
 *
 * @return Object|null
 */
export const getClient = () => {
  return store.getters['simCards/findSimCardsWidgetModule/getClient']
}

/**
 * Load the status data of the SIM cards being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('simCards/findSimCardsWidgetModule/query')
}

/**
 * Add a map or array of object SIM cards that have been selected within
 * the specified set.
 *
 * @param set String
 * @param simCards Array|Map
 */
export const addSelectedSimCards = (set, simCards) => {
  store.commit('simCards/findSimCardsWidgetModule/addSelectedSimCards', { set, simCards })
}

/**
 * Removes an array of SIM cards from the set's list of selected SIM cards.
 * The array must contain the list SIM cards that are no longer selected.
 *
 * @param set String
 * @param simCards cards Array
 */
export const removeSelectedSimCards = (set, simCards) => {
  store.commit('simCards/findSimCardsWidgetModule/removeSelectedSimCards', { set, simCards })
}

/**
 * Return all selected SIM cards
 *
 * @param set
 * @returns {*}
 */
export const simCardSelectionSets = (set) => {
  return store.getters['simCards/findSimCardsWidgetModule/simCardSelectionSets'][set]
}

/**
 * Clears all selected SIM cards within a specified set.
 */
export const clearSelectedSimCards = (set) => {
  store.commit('simCards/findSimCardsWidgetModule/clearSelectedSimCards', set)
}

/**
 * Clears all selected SIM cards.
 */
export const clearAllSelectedSimCards = () => {
  store.commit('simCards/findSimCardsWidgetModule/clearAllSelectedSimCards')
}

/**
 * Returns the selected unit count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedSimCardCount = (set) => {
  return Object.keys(selectedSimCards(set)).length
}

/**
 * Clears all SIM cards from being tracked.
 */
export const purge = () => {
  store.commit('simCards/findSimCardsWidgetModule/purge')
}

/**
 * Sets the client for which the SIM cards should be queried.
 *
 * @param client Object|null
 */
export const setClient = (client) => {
  store.commit('simCards/findSimCardsWidgetModule/setClient', client)
}



// WEBPACK FOOTER //
// ./src/store/sim-cards/findSimCardsWidget.helpers.js